import { useId } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';
import '../../assets/weatherMaps.scss';

export { default as WeatherMapListButton } from './components/WeatherMapListButton/WeatherMapListButton';

const WeatherMapList = ({
  title,
  countLabel,
  children,
  isRefreshing = false,
  refreshingLabel = 'Updating...',
  className,
  listClassName,
}) => {
  const headingId = useId();

  return (
    <section
      aria-labelledby={headingId}
      className={joinClasses(
        'weather-map-list d-flex min-h-0 flex-column overflow-hidden rounded-3 border',
        className,
      )}
    >
      <header className="d-flex flex-shrink-0 align-items-center justify-content-between gap-3 border-bottom px-3 py-2">
        <div className="min-w-0">
          <h2 id={headingId} className="m-0 fs-6 fw-bold">
            {title}
          </h2>
          {countLabel && <div className="small text-secondary">{countLabel}</div>}
        </div>

        {isRefreshing && (
          <span className="small text-secondary" role="status">
            {refreshingLabel}
          </span>
        )}
      </header>

      <ul
        className={joinClasses(
          'weather-map-list-items m-0 min-h-0 list-unstyled overflow-auto',
          listClassName,
        )}
      >
        {children}
      </ul>
    </section>
  );
};

export default WeatherMapList;
